const urlFile={
    file:"http://sis.ashia.sn/file",
    image:"http://sis.ashia.sn/image",
    // file:"http://localhost/file/fichiers",
    // image:"http://localhost/file/fichiers/data"
   }
export default urlFile